import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import MenuButton from '../../../components/Button/MenuButton';
import { ReactComponent as ProfileIcon } from '../../../assets/Profile Black icon.svg';
import { ReactComponent as ProfileIconSelected } from '../../../assets/Profile 1.svg';
import { ReactComponent as PasswordIcon } from '../../../assets/PasswordIcon.svg';
import { ReactComponent as PasswordIconSelected } from '../../../assets/Lock 1.svg';
import { ReactComponent as HeadphoneIcon } from '../../../assets/Headphone Black.svg';
import { ReactComponent as HeadphoneIconSelected } from '../../../assets/Headphone 1.svg';
import LogoutIcon from '../../../assets/Logout.svg';
import LeftArrow from '../../../assets/Left 1.svg';
import SideBarBgContainer from '../../../components/SideBarBgContainer/SideBarBgContainer';
import {
  ProfileContext,
  ProfileContextProps,
} from '../../../context/ProfileContext';
import { storeTab } from '../../../utils/auth-token-utils/cookie';
import './BabysitterSidebar.css';
import { Typography, Box } from '@mui/material';
import { AuthContext } from '../../../context/AuthContext';

const BabysitterSidebar: React.FC = () => {
  const navigate = useNavigate();

  const { activeTab, handleActiveTab, showLogoutPopup, handleShowLogoutPopup } =
    useContext(ProfileContext) as ProfileContextProps;

  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('Auth Context must be used within a AuthProvider');
  }

  const handleLogout = async () => {
    handleShowLogoutPopup(true);
  };

  const handleBackClick = () => {
    navigate('/supervisor/dashboard');
  };

  const handlePasswordSelection = () => {
    handleActiveTab('password');
    storeTab('password');
    navigate('/supervisor/reset-password');
  };

  const handleProfile = () => {
    handleActiveTab('profile');
    storeTab('profile');
    navigate('/supervisor/edit-profile');
  };

  const handleSupport = () => {
    handleActiveTab('support');
    storeTab('support');
    navigate('/supervisor/support');
  };

  return (
    <SideBarBgContainer className="sidebar">
      <Box sx={{ marginX: 'auto' }} className="menu-buttons">
        <img src={LeftArrow} onClick={handleBackClick} className="arrow" />
        <Box sx={{ '& > *:not(:last-child)': { mb: 2 } }}>
          <MenuButton
            icon={
              activeTab === 'profile' ? (
                <ProfileIconSelected />
              ) : (
                <ProfileIcon />
              )
            }
            selected={activeTab === 'profile'}
            onClick={handleProfile}
          >
            Edit Profile
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'password' ? (
                <PasswordIconSelected />
              ) : (
                <PasswordIcon />
              )
            }
            onClick={handlePasswordSelection}
            selected={activeTab === 'password'}
          >
            Change Password
          </MenuButton>
          <MenuButton
            icon={
              activeTab === 'support' ? (
                <HeadphoneIconSelected />
              ) : (
                <HeadphoneIcon />
              )
            }
            onClick={handleSupport}
            selected={activeTab === 'support'}
          >
            Help & Support
          </MenuButton>
        </Box>
      </Box>
      <div className="logout-container" onClick={handleLogout}>
        <div className="logout-icon">
          <img src={LogoutIcon} className="logout-image" alt="Logout" />
        </div>
        <Typography>Logout</Typography>
      </div>
    </SideBarBgContainer>
  );
};

export default BabysitterSidebar;
